import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import {
  openTelegramSupport,
  shouldOpenTelegramSupportInApp,
  telegramSupportHandle,
  toTelegramSupportUrl,
} from '../utils/supportContacts';

export function usePublicSupportContacts() {
  return useQuery({
    queryKey: ['public-support-contacts'],
    queryFn: () => api.getPublicSupportContacts(),
    staleTime: 5 * 60_000,
  });
}

export function useOpenSupportChat() {
  const { data } = usePublicSupportContacts();
  const supportTelegram = data?.supportTelegram;
  const supportEmail = data?.supportEmail;
  const isTelegramMode = shouldOpenTelegramSupportInApp();

  const openTelegram = useCallback(() => {
    openTelegramSupport(supportTelegram);
  }, [supportTelegram]);

  const openSupport = useCallback(() => {
    if (shouldOpenTelegramSupportInApp()) {
      openTelegramSupport(supportTelegram);
      return 'telegram' as const;
    }
    return 'in-app' as const;
  }, [supportTelegram]);

  return {
    supportTelegram,
    supportEmail,
    supportHandle: telegramSupportHandle(supportTelegram),
    supportUrl: toTelegramSupportUrl(supportTelegram),
    openSupport,
    openTelegram,
    isTelegramMode,
  };
}
